import React, { Suspense, lazy } from 'react';
import Loader from './loader';

const TabTeam = lazy(() => import('./index'));

function TabTeamLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <TabTeam {...props} />
        </Suspense>
    );
}

export default TabTeamLazy;
export { TabTeamLazy };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-team/lazy.js